function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/manager/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const managerRoutes = [
  {
    path: '/manager/dashboard',
    component: view('GraphCustomerInformation'),
    name: 'manager.dashboard',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Dashboard',
          active: true
        }
      ]
    }
  }
]

export default managerRoutes
